"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralsApi = void 0;
var runtime = __importStar(require("../runtime"));
var RedeemReferralDto_1 = require("../models/RedeemReferralDto");
var ReferralsControllerMyCodeV1200Response_1 = require("../models/ReferralsControllerMyCodeV1200Response");
var ReferralsControllerMyRewardsV1200Response_1 = require("../models/ReferralsControllerMyRewardsV1200Response");
var ReferralsControllerMySummaryV1200Response_1 = require("../models/ReferralsControllerMySummaryV1200Response");
var ReferralsControllerRedeemV1200Response_1 = require("../models/ReferralsControllerRedeemV1200Response");
/**
 *
 */
var ReferralsApi = /** @class */ (function (_super) {
    __extends(ReferralsApi, _super);
    function ReferralsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates request options for referralsControllerMyCodeV1 without sending the request
     */
    ReferralsApi.prototype.referralsControllerMyCodeV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/referrals/me/code";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Returns the current user\'s referral code plus a shareable https URL and a native deeplink. Codes are 8-char uppercase alphanumeric and created on-demand — new users don\'t pay the write cost until they open the referral card.
     * Get my referral code (lazy-created on first call)
     */
    ReferralsApi.prototype.referralsControllerMyCodeV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.referralsControllerMyCodeV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, ReferralsControllerMyCodeV1200Response_1.ReferralsControllerMyCodeV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the current user\'s referral code plus a shareable https URL and a native deeplink. Codes are 8-char uppercase alphanumeric and created on-demand — new users don\'t pay the write cost until they open the referral card.
     * Get my referral code (lazy-created on first call)
     */
    ReferralsApi.prototype.referralsControllerMyCodeV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.referralsControllerMyCodeV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for referralsControllerMyRewardsV1 without sending the request
     */
    ReferralsApi.prototype.referralsControllerMyRewardsV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/referrals/me/rewards";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * Reward records track *what was issued*, separate from the ledger which tracks *what is spendable*. Useful for support / audit; the mobile \"rewards history\" screen renders these directly.
     * List rewards I earned (as referrer or referee)
     */
    ReferralsApi.prototype.referralsControllerMyRewardsV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.referralsControllerMyRewardsV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, ReferralsControllerMyRewardsV1200Response_1.ReferralsControllerMyRewardsV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Reward records track *what was issued*, separate from the ledger which tracks *what is spendable*. Useful for support / audit; the mobile \"rewards history\" screen renders these directly.
     * List rewards I earned (as referrer or referee)
     */
    ReferralsApi.prototype.referralsControllerMyRewardsV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.referralsControllerMyRewardsV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for referralsControllerMySummaryV1 without sending the request
     */
    ReferralsApi.prototype.referralsControllerMySummaryV1RequestOpts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/referrals/me";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }];
                }
            });
        });
    };
    /**
     * One-shot payload for the mobile \"Refer & earn\" card. Includes: my share code, counters for people I referred, whether I have redeemed someone else\'s code, and my current credit ledger snapshot (pending credit count + days left on the active credit).
     * My referral summary — code, referrer stats, referee state, credit balance
     */
    ReferralsApi.prototype.referralsControllerMySummaryV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.referralsControllerMySummaryV1RequestOpts()];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, ReferralsControllerMySummaryV1200Response_1.ReferralsControllerMySummaryV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * One-shot payload for the mobile \"Refer & earn\" card. Includes: my share code, counters for people I referred, whether I have redeemed someone else\'s code, and my current credit ledger snapshot (pending credit count + days left on the active credit).
     * My referral summary — code, referrer stats, referee state, credit balance
     */
    ReferralsApi.prototype.referralsControllerMySummaryV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.referralsControllerMySummaryV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates request options for referralsControllerRedeemV1 without sending the request
     */
    ReferralsApi.prototype.referralsControllerRedeemV1RequestOpts = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['redeemReferralDto'] == null) {
                            throw new runtime.RequiredError('redeemReferralDto', 'Required parameter "redeemReferralDto" was null or undefined when calling referralsControllerRedeemV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/referrals/redeem";
                        return [2 /*return*/, {
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, RedeemReferralDto_1.RedeemReferralDtoToJSON)(requestParameters['redeemReferralDto']),
                            }];
                }
            });
        });
    };
    /**
     * Enqueues a **1-month Pro credit** into the ledger for the *referee* (the current user).  The credit activates immediately when the referee has no active RC subscription, no free trial in progress, and no waitlist Champion year. Otherwise it stays `credit_pending` and activates automatically when those clear.  For the *referrer* (whose code was used): a credit is only issued on every Nth completed referral (default N=3, configurable via the active policy). Below the threshold, `referrerOutcome=\'skipped_below_threshold\'`.  Guards enforced server-side: **no self-referral**, **one redemption per user (UNIQUE(referee_id))**, **attribution window** from signup.  A code stops accepting redemptions after its referrer reaches the configured benefit cap (default: 12 Pro months / 36 successful referrals).
     * Redeem a referral code (referee earns 1 month Pro credit)
     */
    ReferralsApi.prototype.referralsControllerRedeemV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.referralsControllerRedeemV1RequestOpts(requestParameters)];
                    case 1:
                        requestOptions = _a.sent();
                        return [4 /*yield*/, this.request(requestOptions, initOverrides)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, ReferralsControllerRedeemV1200Response_1.ReferralsControllerRedeemV1200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Enqueues a **1-month Pro credit** into the ledger for the *referee* (the current user).  The credit activates immediately when the referee has no active RC subscription, no free trial in progress, and no waitlist Champion year. Otherwise it stays `credit_pending` and activates automatically when those clear.  For the *referrer* (whose code was used): a credit is only issued on every Nth completed referral (default N=3, configurable via the active policy). Below the threshold, `referrerOutcome=\'skipped_below_threshold\'`.  Guards enforced server-side: **no self-referral**, **one redemption per user (UNIQUE(referee_id))**, **attribution window** from signup.  A code stops accepting redemptions after its referrer reaches the configured benefit cap (default: 12 Pro months / 36 successful referrals).
     * Redeem a referral code (referee earns 1 month Pro credit)
     */
    ReferralsApi.prototype.referralsControllerRedeemV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.referralsControllerRedeemV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ReferralsApi;
}(runtime.BaseAPI));
exports.ReferralsApi = ReferralsApi;
